export default {
  init() {
    const fadeInImages = () => {
      const images = document.querySelectorAll("img[data-fade-in]");

      images.forEach(img => {
        if (img.complete) {
          img.classList.add("is-loaded");
        } else {
          img.addEventListener(
            "load",
            () => img.classList.add("is-loaded"),
            { once: true }
          );
        }
      });
    };

    // initial run
    fadeInImages();

    // observe for new images added later
    const observer = new MutationObserver(fadeInImages);
    observer.observe(document.body, { childList: true, subtree: true });
  }
};
